// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"335":"24017888","339":"24017888","674":"57e7ae01"}[chunkId] + ".chunk.css";
};